<div class="py-2 max-w-5xl mx-auto">

    <!-- Top Header & Search Bar -->
    <div class="mb-6">
        <h3 class="text-[22px] font-bold text-gray-800 !m-0 !mb-4 capitalize text-center">Frequently Asked Questions
        </h3>

        <!-- Search Input with Theme Full Width Input -->
        <div class="w-full my-4">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full faq-search-field">
                <mat-icon matPrefix class="faq-search-prefix-icon">search</mat-icon>
                <mat-label>Search FAQs</mat-label>
                <input matInput type="text" class="browser-default" [(ngModel)]="searchQuery"
                    placeholder="Search any problem, feature, or installation step..." autocomplete="off" />
                <button *ngIf="searchQuery" mat-icon-button matSuffix type="button" (click)="clearSearch()"
                    aria-label="Clear search" class="faq-clear-btn">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <div *ngIf="searchQuery" class="mt-2 text-center text-[13px] text-gray-500 font-medium">
                Found {{ filteredItems.length }} {{ filteredItems.length === 1 ? 'result' : 'results' }} matching "<span
                    class="text-gray-700 font-semibold">{{ searchQuery }}</span>"
            </div>
        </div>
    </div>

    <!-- Category Pill Filters -->
    <div class="flex items-center gap-2 mb-4 overflow-x-auto pb-1 no-scrollbar scroll-smooth">
        @for (cat of categories; track cat) {
        <button (click)="setActiveFilter(cat)"
            class="category-chip px-5 py-1.5 rounded-full text-[13px] font-semibold transition-all duration-200 whitespace-nowrap border shadow-sm outline-none"
            [class.is-active]="activeFilter === cat">
            {{ cat }}
        </button>
        }
    </div>

    <!-- Accordion Section -->
    <div class="bg-white rounded-xl border border-gray-100 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07)] overflow-hidden">
        <cdk-accordion class="divide-y divide-gray-50">
            @for (item of filteredItems; track item.id; let index = $index) {
            <cdk-accordion-item #accordionItem="cdkAccordionItem" class="block" role="listitem" tabindex="0"
                [attr.id]="'accordion-header-' + index" [attr.aria-expanded]="accordionItem.expanded"
                [attr.aria-controls]="'accordion-body-' + index">

                <!-- Accordion Header -->
                <div class="flex items-center justify-between py-5 cursor-pointer group hover:bg-gray-50/50 px-5 transition-colors"
                    (click)="accordionItem.toggle()">
                    <div class="flex items-center gap-4">
                        <!-- Icon Container -->
                        <div
                            class="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg bg-[#5459d1]/5 text-[#5459d1] group-hover:bg-[#5459d1]/10 transition-colors border border-[#5459d1]/10">
                            <span class="material-icons-outlined text-[17px]">{{ item.iconName }}</span>
                        </div>
                        <!-- Question Text -->
                        <h3
                            class="text-[14px] font-bold text-gray-800 leading-tight group-hover:text-[#5459d1] transition-colors !m-0">
                            {{ item.title }}
                        </h3>
                    </div>
                    <!-- Expansion Icon -->
                    <span
                        class="material-icons-outlined text-gray-300 group-hover:text-[#5459d1] transition-all duration-300 ease-in-out"
                        [class.rotate-180]="accordionItem.expanded" [class.!text-[#5459d1]]="accordionItem.expanded">
                        expand_more
                    </span>
                </div>

                <!-- Accordion Body -->
                <div class="overflow-hidden transition-all duration-300 ease-in-out"
                    [style.display]="accordionItem.expanded ? 'block' : 'none'" [attr.id]="'accordion-body-' + index"
                    [attr.aria-labelledby]="'accordion-header-' + index">
                    <div class="pb-6 px-8 text-[14px] font-normal text-gray-600 leading-relaxed faq-answer-content">
                        <div [innerHTML]="item.description"></div>

                        <!-- Video Link Section -->
                        @if (item.videoUrl) {
                        <div class="mt-4">
                            <a [href]="item.videoUrl" target="_blank" class="faq-video-redirect-link">
                                <span class="material-symbols-outlined">play_circle</span>
                                Watch Tutorial Video
                            </a>
                        </div>
                        }
                    </div>
                </div>
            </cdk-accordion-item>
            }

            <!-- Empty State -->
            @if (filteredItems.length === 0) {
            <div class="py-16 text-center">
                <div
                    class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gray-50 !mb-3 text-gray-300">
                    <span class="material-icons-outlined text-2xl">search_off</span>
                </div>
                <h3 class="text-base font-semibold text-gray-900 !my-1">No results found</h3>
                <p class="text-sm text-gray-500 !mt-1" *ngIf="searchQuery">
                    No questions or details matched "<span class="font-semibold text-gray-700">{{ searchQuery
                        }}</span>".
                </p>
                <p class="text-sm text-gray-500 !mt-2" *ngIf="!searchQuery">Try adjusting your filter to find what
                    you're
                    looking for.</p>
                <button *ngIf="searchQuery || activeFilter !== 'All'" (click)="clearSearch(); setActiveFilter('All')"
                    type="button"
                    class="mt-4 px-4 py-2 text-[13px] font-semibold text-[#5459d1] bg-[#5459d1]/10 rounded-lg hover:bg-[#5459d1]/20 transition-colors !border-none">
                    Reset search & filters
                </button>
            </div>
            }
        </cdk-accordion>
    </div>
</div>